// extracted by mini-css-extract-plugin
module.exports = {"customBtn":"custom-button-select_customBtn__Ua2Wp","customBtnBr0":"custom-button-select_customBtnBr0__qsYRc"};